import { jsx as _jsx } from "react/jsx-runtime";
import { useRouter } from '@tribeplatform/react-sdk';
import { Badge } from '@tribeplatform/react-ui-kit/Badge';
export const TagPill = ({ title, active, className }) => (_jsx(Badge, { size: "lg", variant: active ? 'primary' : 'secondary', className: className, children: title }, void 0));
// eslint-disable-next-line @typescript-eslint/ban-types
export function isFunction(value) {
    return typeof value === 'function';
}
export const TagPillWithLink = ({ link, className, ...pillProps }) => {
    const { Link } = useRouter();
    let to = '';
    if (isFunction(link)) {
        to = link();
    }
    else {
        to = link;
    }
    return (_jsx(Link, { href: to, className: className, children: _jsx(TagPill, { ...pillProps }, void 0) }, void 0));
};
//# sourceMappingURL=TagPill.js.map